import React from 'react';
import './HeroImage.scss';

export type HeroImageProps = {
    hasCroppedLogo: boolean;
    croppedLogoUrl480: string;
    croppedLogoUrl600: string;
    croppedLogoUrl800: string;
    eventName: string;
};

export const HeroImage = ({
    hasCroppedLogo,
    croppedLogoUrl480,
    croppedLogoUrl600,
    croppedLogoUrl800,
    eventName,
}: HeroImageProps) => {
    const Image = () => {
        return (
            <div className="hero-image fx--delay-6 fx--fade-in">
                <picture>
                    <source
                        srcSet={`
                            ${croppedLogoUrl480} 480w,
                            ${croppedLogoUrl600} 600w,
                            ${croppedLogoUrl800} 800w`}
                        sizes="
                            (max-width:480px) 480px,
                            (max-width:600px) 600px,
                            800px
                        "
                    />
                    <img
                        width="auto"
                        height="auto"
                        alt={eventName}
                        src={croppedLogoUrl600}
                    />
                </picture>
            </div>
        );
    };

    return <>{hasCroppedLogo && <Image />}</>;
};
